<template>
  <div v-if="basket"
		class="basket-block panel panel-default sidebar-menu wow fadeInLeft animated"
		style="visibility: visible;">
		<div class="panel-heading">
			<h1 class="panel-title">{{ $t("basket.title") }}</h1>

      <a v-if="views.smallBasketCollapsed"
        class="toggle-basket-visibility hidden-md hidden-lg"
        @click="showBasket">
        <i class="fa fa-chevron-right"></i>
      </a>
			<a v-else class="toggle-basket-visibility hidden-md hidden-lg" @click="hideBasket">
        <i class="fa fa-chevron-down"></i>
      </a>

			<small v-if="views.smallBasketCollapsed" class="hidden-md hidden-lg float-right">
				{{ $filters.formatMoney(basket.computed.total) }}
			</small>
    </div>

    <div class="panel-body text-widget" :class="views.smallBasketCollapsed ? 'hide-basket' : 'show-basket'">
      <ul class="list-unstyled">
				<li v-if="shoppingCart.booth_type !== null">
					<b>{{ $t("basket.booth_type") }}: </b>{{ $t(shoppingCart.booth_type.translation_key) }}
				</li>

				<li v-if="squareMeter > 0">
					<b>{{ $t("basket.size") }}: </b>{{ $filters.formatLength(shoppingCart.width) }} x {{ $filters.formatLength(shoppingCart.depth) }} m ({{ $filters.formatLength(squareMeter) }} {{ $t("labels.sqm") }})
				</li>

				<li v-if="basket.exhibitionHall != null && basket.exhibitionHall != ''">
					<b>{{ $t("labels.exhibition_hall") }}: </b>{{ basket.exhibitionHall }}
				</li>

				<li v-if="basket.exhibitionBoothNumber != null && basket.exhibitionBoothNumber != ''">
					<b>{{ $t("labels.exhibition_booth_number") }}: </b>{{ basket.exhibitionBoothNumber }}
				</li>
			</ul>

      <table class="table table-condensed">
				<thead>
					<tr>
						<th colspan="2">
							<div class="">
								{{ $t("basket.item") }}<span class="basket-price-label">{{ $t("basket.price_in") }}</span>
							</div>
						</th>
					</tr>
				</thead>

        <tbody>
          <tr v-if="basket.selectedBooth != null">
						<th colspan="2">{{ $t("summary.package") }}</th>
					</tr>
					<tr v-if="basket.selectedBooth != null">
						<td>{{ $t("basket.booth_package") }} (<span v-if="basket.selectedBooth != null">{{ basket.selectedBooth.displayName }}</span>) :</td>
						<td class="text-right width--25">{{ $filters.formatMoney(costs.boothCost) }}</td>
					</tr>

          <tr v-if="basket.showArticles || shoppingCart.print_items.length > 0">
						<th colspan="2">{{ $t("summary.articles") }}</th>
					</tr>

          <BasketArticle v-for="(article,paIndex) in shoppingCart.print_items"
						:key="paIndex"
						:article="article" />

          <template v-for="(article,aIndex) in shoppingCart.items"
						:key="aIndex">
            <BasketArticle v-if="article.count > 0" :article="article" />
          </template>
					
					<tr>
						<th colspan="2" v-if="costs.additionalCosts.length > 0">
              {{ $t("summary.other_costs") }}
            </th>
					</tr>

					<tr v-if="costs.additionalCosts.length > 0" v-for="cost in costs.additionalCosts" :value="cost">
						<td>{{ cost.displayName }} </td>
						<td class="text-right width--25">{{ $filters.formatMoney(cost.amount) }}</td>
					</tr>

					<tr v-if="costs.exhibitionRentCost > 0">
						<td>{{ $t("basket.rent") }}:</td>
						<td class="text-right width--25">{{ $filters.formatMoney(costs.exhibitionRentCost) }}</td>
					</tr>
        </tbody>

        <tfoot>
					<tr v-if="isPriceLevelActive">
						<td>{{ (inEnglish) ? activePriceLevel.name_en : activePriceLevel.name }} ({{ activePriceLevel.percentage }}%):</td>
						<td class="text-right width--25">{{ $filters.formatMoney(costs.priceLevelCost) }}</td>
					</tr>
					<tr>
						<th>{{ $t("basket.total") }}:</th>
						<th class="text-right width--25">{{ $filters.formatMoney(costs.total) }}</th>
					</tr>
					<tr v-if="!netValuesOnly">
						<th>{{ $filters.replaceVatRate($t('basket.total_gross'), 19) }}:</th>
						<th class="text-right width--25">{{ $filters.formatMoney(costs.total_gross) }}</th>
					</tr>
				</tfoot>
      </table>
    </div>
  </div>
</template>

<script setup>
import { useMainStore } from '@/store'
import { computed } from 'vue'

const store = useMainStore()
// props
const props = defineProps({
  views: {
    type: Object,
    required: true
  }
})

// emits
const emit = defineEmits(['toggleBasket'])

// computed props
const shoppingCart = computed(() => store.settings.shopping_cart)
const basket = computed(() => store.settings.basket)
const costs = computed(() => store.costs)
const activePriceLevel = computed(() => store.activePriceLevel)
const inEnglish = computed(() => store.inEnglish)
const netValuesOnly = computed(() => store.tmp.net_value_only)

const squareMeter = computed(() => {
	if (shoppingCart.value.width > 0 && shoppingCart.value.depth > 0) {

		return shoppingCart.value.getSquareMeter()
	}

	return 0.0
})

const isPriceLevelActive = computed(() => {

	return (activePriceLevel.value !== null)
})

// methods
const showBasket = () => {
  emit('toggleBasket', false)
}

const hideBasket = ()=> {
  emit('toggleBasket', true)
}
</script>